import { heatmapCollect } from './heatmap-collect.js';
import { heatmapPreview } from './heatmap-preview.js';
import { heatmapSocketCv } from './heatmap-sock-cv.js';
(function () {
  const startHeatmap = async() => {
    const p = new URL(location.href).searchParams;

    if(p.get('heatmap_preview')) {
      if(p.get('heatmap_preview') === 'on') {
        const squareModule = await import('./heatmap4square.js');
        const clickModule  = await import('./heatmap4click.js');
        window.h337square = squareModule.default || squareModule.h337square || squareModule;
        window.h337 = clickModule.default  || clickModule.h337       || clickModule;

        heatmapPreview();
        return;
      }
    }

    if(p.get('heatmap_sock_cv')) {
      heatmapSocketCv();
      return;
    }

    heatmapCollect();
  };

  // An async tag can arrive after DOMContentLoaded has already fired.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startHeatmap, { once: true });
  } else {
    startHeatmap();
  }
})();
